import { render, staticRenderFns } from "./LahanExportModal_socialImpactOfficer.vue?vue&type=template&id=e80ece4c"
import script from "./LahanExportModal_socialImpactOfficer.vue?vue&type=script&lang=js"
export * from "./LahanExportModal_socialImpactOfficer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports